import SectionTitle from "features/無料占いコンテンツ/components/atoms/SectionTitle";
import { FortuneTellerMenuList } from "features/fortune-tellers/components/FortuneTellerMenuList";
import { FreeFortuneContent } from "shared/types";

interface Props {
  freeFortuneContent: FreeFortuneContent;
}

export const FortuneTellerMenu = ({ freeFortuneContent }: Props) => {
  return (
    <div tw="px-4 mt-10">
      <div tw="-mb-4">
        <SectionTitle
          readMore
          readMoreLink={`/fortune_tellers/list/${freeFortuneContent.fortuneTeller.id}`}
        >
          {freeFortuneContent.fortuneTeller.name}のチャット鑑定メニュー
        </SectionTitle>
      </div>
      <FortuneTellerMenuList
        title=""
        menus={freeFortuneContent.fortuneTeller.fortunes}
        fortuneTeller={freeFortuneContent.fortuneTeller}
      />
    </div>
  );
};
